// @flow

import { useLocation, matchPath, useSearchParams } from 'react-router-dom';

import { selectCountItems, selectCartWidgetVisible } from '@gandi/cart';

import { useAppSelector } from './useAppSelector';

export function useCartTrayVisible(): { cartTrayDisplayed: boolean } {
  const location = useLocation();

  const [searchParams] = useSearchParams();

  const matchedRoute = ['/cart/*'].some(route =>
    matchPath(route, location.pathname),
  );

  const transferBulkRoute =
    ['/domain/transfer/*'].some(route => matchPath(route, location.pathname)) &&
    searchParams.has('bulk');

  const productsCount = useAppSelector(selectCountItems);
  const cartWidgetIsVisible = useAppSelector(selectCartWidgetVisible);

  const cartTrayDisplayed = !!productsCount && !cartWidgetIsVisible;
  return {
    cartTrayDisplayed: cartTrayDisplayed && !matchedRoute && !transferBulkRoute,
  };
}
